$( document ).ready( function() {
    
    var SiteHeader = {
        $elem: $( '.site-header' ),
        isSticky: false,
        isInit: false,
        threshold: 0,
        breakpoint: 900
    };

    SiteHeader.init = function( threshold ) {
        this.threshold = threshold;

        $( window ).on( 'resize', this._onResizeListener );

        if ( window.innerWidth >= this.breakpoint ) {
            this.setup();
            if (this.shouldBeSticky()) {
                this.sticky();
            }
        }
    }


    SiteHeader.setup = function() {
        if ( this.isInit ) return;

        $( window ).on( 'scroll', this._onScrollListener );

        this.isInit = true;
    };
    SiteHeader.teardown = function() {
        if ( !this.isInit ) return;

        if ( this.isSticky ) {
            this.unsticky();
        }
        $( window ).off( 'scroll', this._onScrollListener );

        this.isInit = false;
    };


    SiteHeader.sticky = function() {
        this.$elem.addClass( 'is-sticky' );
        this.isSticky = true;
    };
    SiteHeader.unsticky = function() {
        this.isSticky = false;
        this.$elem.removeClass( 'is-sticky' );
    };
    SiteHeader.shouldBeSticky = function() {
        return (window.scrollY > SiteHeader.threshold);
    };

    SiteHeader._onScrollListener = function(e) {
        if ( SiteHeader.shouldBeSticky() ) {
            SiteHeader.sticky();
        } else {
            SiteHeader.unsticky();
        }
    };
    SiteHeader._onResizeListener = function(e) {
        if ( window.innerWidth >= SiteHeader.breakpoint ) {
            SiteHeader.setup();
        } else {
            SiteHeader.teardown();
        }
    };

    // sticky header on front page after scrolling one vp height
    var threshold = 0;
    if ( $( document.body).hasClass( 'home' ) ) {
        threshold = window.innerHeight;
    } else {
        threshold = parseInt( SiteHeader.$elem.css( 'height' ), 10 );
    }
    SiteHeader.init( threshold );
});